import React from "react";
import { Collapse } from 'reactstrap';
import { withLocalize, Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { SemaphoreGroup } from "../../common/semaphors";
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import HistoryLink from "../../common/historyLink";

class SemaphoreHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            isExpandedTouched: false,
            semaphores: props.data.filter(x => x.type === "01"),
            semaphoreGroups: props.data.filter(x => x.type === "02")
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({
                isExpandedTouched: false,
                semaphores: this.props.data.filter(x => x.type === "01"),
                semaphoreGroups: this.props.data.filter(x => x.type === "02")
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.semaphores.length + this.state.semaphoreGroups.length > 0 && <HistoryLink
                    historyExpanded={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)} onClick={this.expand}
                />}
                <Collapse isOpen={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)}>
                    {this.state.semaphores.length > 0 && <table className={`table table-condensed table-report-section ${this.state.semaphores.length > 3 ? "has-pseudo" : ""}`} style={{borderCollapse:"collapse", width:"100%"}}>
                        <thead>
                            <tr>
                                <th className="is-40"><Translate id="Report.Ratings.SemaphoreCribis" /></th>
                                <th className="is-30"><Translate id="Report.Common.ValidFrom" /></th>
                                <th className="is-30"><Translate id="Report.Common.ValidTo" /></th>
                                {this.state.semaphores.length > 3 && <th className="pseudo-column"></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.semaphores.map((d, i) => {
                                return (
                                    <tr key={i}>
                                        <td className="is-40"><SemaphoreGroup value={parseInt(d.code, 10)} size={"small"}  ></SemaphoreGroup></td>
                                        <td className="is-30">{d.startFormated}</td>
                                        <td className="is-30">{d.endFormated}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>}
                    {this.state.semaphoreGroups.length > 0 && <table className={`table table-report-section ${this.state.semaphoreGroups.length > 3 ? "has-pseudo" : ""}`}>
                        <thead>
                            <tr>
                                <th className="is-40"><Translate id="Report.Ratings.GroupSemaphoresCribis" /></th>
                                <th className="is-30"><Translate id="Report.Common.ValidFrom" /></th>
                                <th className="is-30"><Translate id="Report.Common.ValidTo" /></th>
                                {this.state.semaphoreGroups.length > 3 && <th className="pseudo-column"></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.semaphoreGroups.map((d, i) => {
                                return (
                                    <tr key={i}>
                                        <td className="is-40"><SemaphoreGroup value={parseInt(d.code, 10)} size={"small"}  ></SemaphoreGroup></td>
                                        <td className="is-30">{d.startFormated}</td>
                                        <td className="is-30">{d.endFormated}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>}
                </Collapse>
            </React.Fragment>
        )
    }
    expand = () => {
        this.setState(
            {
                expanded: !this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched),
                semaphores: this.props.data.filter(x => x.type === "01"),
                semaphoreGroups: this.props.data.filter(x => x.type === "02"),
                isExpandedTouched: true
            })
    }
}

export default withLocalize(connect(
    state => state.report, dispatch => bindActionCreators(reportActions, dispatch)
)(SemaphoreHistory));